<template>
  <el-select
    :class="{'no-show-last':selectedAll}"
    popper-class="dashboard-area-popper"
    :clearable="clearable"
    :disabled="disabled"
    filterable
    :value="value"
    @change="changeHandle"
    @visible-change="resetFilterText"
    :multiple="multiple"
    ref="select"
  >

    <slot>
      <el-input
        v-if="multiple"
        class="out-input"
        :value="filterText"
        clearable
        @click.stop
        @input="debouncedQueryChange"
      />
      <el-option
        v-if="multiple"
        :value="-1"
      >
        <span>全选</span>
        <span class="inner-input"> </span>
      </el-option>
    </slot>
    <el-option
      v-for="(item, index) in filterList"
      :key="index"
      :value="item.id"
      :label="item.areaName"
    ></el-option>
  </el-select>
</template>

<script>
import debounce from 'throttle-debounce/debounce';
import areaMixin from './mixin.js';

export default {
  name: 'dashboard-area-select',
  props: {
    size: String,
    value: {
      required: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedAll: false,
      filterText: '',
    };
  },
  created() {
    this.debouncedQueryChange = debounce(this.debounce, value => {
      this.handleQueryChange(value);
    });
    if (this.value && this.value.find(item => item === -1)) {
      this.selectedAll = true;
    }
  },
  computed: {
    filterList() {
      return this.dashboardArea.filter(item => {
        if (item.value == -1) return true;
        if (this.filterText) {
          return item.areaName.indexOf(this.filterText) > -1;
        } else {
          return true;
        }
      });
    },
  },
  mixins: [areaMixin],
  methods: {
    changeHandle(val) {
      if (val) {
        if (this.selectedAll) {
          if (val && val.length && val.indexOf(-1) > -1) {
            this.$emit('input', val.filter(id => id !== -1));
          } else {
            this.$emit('input', []);
          }
          this.selectedAll = false;
        } else {
          if (val && val.length && val.indexOf(-1) > -1) {
            this.selectedAll = true;
            this.$emit('input', [
              ...this.dashboardArea.map(item => item.id),
              -1,
            ]);
          } else if (val.length === this.dashboardArea.length) {
            this.selectedAll = true;
            this.$emit('input', [...val, -1]);
          } else {
            this.$emit('input', val);
          }
        }
      } else {
        this.$emit('input', null);
      }
    },
    handleQueryChange(val) {
      this.filterText = val;
    },
    resetFilterText(visible) {
      if (!visible) this.filterText = '';
    },
  },
};
</script>

<style lang="scss">
.dashboard-area-popper {
  .el-select-dropdown__list {
    position: relative;
  }
  .out-input,
  .inner-input {
    display: inline-block;
    width: 100px;
    margin-left: 20px;
  }
  .out-input {
    position: absolute;
    right: 40px;
    top: 23px;
    transform: translateY(-50%);
    z-index: 1;
  }
  .inner-input {
    line-height: inherit;
  }
}
.el-select.no-show-last {
  .el-select__tags {
    .el-tag.el-tag--info {
      &:last-child {
        display: none;
      }
    }
  }
}
</style>
